import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import exportFromBlob from "helpers/export-from-blob";
import { requestMerchandiserPayRate } from "actions/draftActions";

class DownloadMerchandiserPayRateButton extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick = () => {
        this.props.requestMerchandiserPayRate((contactsReport) => {
            const fileName = `job-merchandiser-pay-rate-report-${moment().format("YYYY-MM-DD")}.xlsx`;
            exportFromBlob(contactsReport, fileName);
        });
    };

    render() {
        const {
            className,
            title
        } = this.props;

        return (
            <button
                className={className}
                onClick={this.handleClick}
            >
                {title}
            </button>
        );
    }
}

DownloadMerchandiserPayRateButton.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
};

const mapStateToDispatch = dispatch => ({
    requestMerchandiserPayRate: bindActionCreators(requestMerchandiserPayRate, dispatch),
});

export default connect(
    null,
    mapStateToDispatch
)(DownloadMerchandiserPayRateButton);
